module.exports = __webpack_public_path__ + "static/media/photo-10.c91c0f1c.webp";